module.exports = __webpack_public_path__ + "static/media/alertTriangle.4cd956d2.svg";